export default __webpack_public_path__ + "static/media/gasag_xl1.caff2415.png";